import React from "react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { ProductCard } from "@/components/product/ProductCard";
import { useProducts } from "@/hooks/useCatalog";

export function NewArrivals({ onQuickView }) {
  const { data } = useProducts({ tag: "new", limit: 10, sort: "newest" });
  const items = data?.items || [];

  return (
    <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <SectionHeading
        eyebrow="Just Landed"
        title="New Arrivals"
        align="left"
        link={{ label: "View All", to: "/collections/new-arrivals", testId: "new-arrivals-view-all" }}
      />
      <div className="no-scrollbar mt-12 flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2 sm:gap-8" data-testid="new-arrivals-scroller">
        {items.map((p) => (
          <div key={p.handle} className="w-[68%] shrink-0 snap-start sm:w-[42%] lg:w-[23%]">
            <ProductCard product={p} onQuickView={onQuickView} />
          </div>
        ))}
      </div>
    </section>
  );
}
